import React from 'react'

import './Breadcrumbs.scss'
import { Route as RouteC, Link } from 'react-router-dom'
import Route from 'route-parser'

let routes = []
let routesOriginal = []

const findRouteName = url => {
    let achei = Object.keys(routes).find(r => routes[r]['rota'].match(url))
    if (achei) {
        return achei
    }
}

const getPaths = pathname => {
    const paths = [new Route('/')]

    if (pathname === '/') return paths

    pathname.split('/').reduce((prev, curr, index) => {
        const currPath = `${prev}/${curr}`
        paths.push(new Route(currPath.toString()))
        //console.log(currPath);
        return currPath
    })
    //console.log(paths);
    return paths
}

const BreadcrumbsItem = ({ match, ...rest }) => {
    const routeName = findRouteName(match.url)
    let targetUrl = match.url
    let btParams = sessionStorage.getItem('bt-params')
    if (btParams) {
        btParams = JSON.parse(btParams)
        if (btParams[routeName]) {
            targetUrl = btParams[routeName]
        }
    }
    if (routeName) {
        return match.isExact ? (
            <li className="breadcrumbs-item breadcrumbs-itemAtual">{routesOriginal[routeName].marca}</li>
        ) : (
            <li className="breadcrumbs-item">
                <Link to={targetUrl || ''}>{routes[routeName].marca}</Link>
            </li>
        )
    }
    return null
}

const Breadcrumbs = ({ location: { pathname }, match, ...rest }) => {
    // Busca por correspondência na lista original de rotas

    Object.keys(routes).forEach(r => {
        let result = routes[r]['rota'].match(pathname)
        // Se encontrar e tiver parâmetros, armazena

        if (result && result.param) {
            routes[r].marca = JSON.parse(decodeURIComponent(atob(result.param))).titulo
            let btParams = sessionStorage.getItem('bt-params')
            if (!btParams) {
                btParams = {}
            } else {
                btParams = JSON.parse(btParams)
            }
            btParams[r] = pathname
            sessionStorage.setItem('bt-params', JSON.stringify(btParams))
        }
    })
    const paths = getPaths(pathname)
    return (
        <>
            <ul className="breadcrumb">
                <li className="breadcrumbs-item voceEsta">{paths.length > 0 ? 'Você está em:' : ''}</li>
                {paths.map((p, i) => (
                    <RouteC key={i} path={p.spec} component={BreadcrumbsItem} />
                ))}
            </ul>
        </>
    )
}

export default props => {
    props.programas.map(p => (routes[p.id] = { marca: p.marca, rota: new Route(p.path) }))

    props.programas.map(p => (routesOriginal[p.id] = { marca: p.marca, rota: new Route(p.path) }))

    return (
        <div className="breadcrumbArea">
            <RouteC path="/:path" component={Breadcrumbs} {...props} />
        </div>
    )
}
